"use strict";

const $ = jQuery;
const boostrap = window.bootstrap;
const JumboMenu = require('./jumbo-menu-2024.js');

module.exports = class {
    #$window;
    #$html;
    #$body;
    #$header;
    #$headerNav;
    #$alertBar;
    #$topBar;
    #$bottomBar;
    #$primaryNav;
    #$primaryNavContainer;
    #$primaryNavDropdownMenus;
    #$primaryNavDropdownToggles;
    #$mobilePrimaryNavToggle;
    #jumboMenu;
    headerBottomPadding;


	constructor() {
		this.#$window = $(window);
        this.#$html = $('html');
        this.#$body = $('body');
        this.#$header = this.#$body.find('#header--site');

        if (this.#$header.length === 0) {
            return null;
        }

        this.#$headerNav = this.#$header.find('#header-nav');

        this.#$alertBar = this.#$header.children('.alert');
        this.#$topBar = this.#$header.find('.top-bar');
        this.#$bottomBar = this.#$header.find('.bottom-bar');
        this.#$primaryNav = this.#$header.find('nav#navbar');
        this.#$primaryNavContainer = this.#$primaryNav.children('.navbar-container');
        this.#$primaryNavDropdownMenus = this.#$primaryNavContainer.find('ul.dropdown-menu');
        this.#$primaryNavDropdownToggles = this.#$primaryNavContainer.find('button.dropdown-toggle');
        this.#$mobilePrimaryNavToggle = this.#$bottomBar.find('.mobile-navbar-toggle button');

        this.headerBottomPadding = 0;

        this.bind();

        if (!this.#$header.hasClass('no-scrolling')) {
            this.updateScroll();
        }

        if (this.#$headerNav.hasClass('jumbo-menu')) {
            this.#jumboMenu = new JumboMenu({ siteHeader: this });
        }

        this.#$header.addClass('initialized');
        this.#$header.trigger('site-header:initialized');
	}

    bind() {
        this.$window.on('resize', (event) => { this.onWindowResize(event); });
        this.$mobilePrimaryNavToggle.on('click', (event) => { this.onMobilePrimaryNavToggleClick(event); });

        if (!this.#$header.hasClass('no-scrolling')) {
            $(this.$window, this.$html, this.$body).on('scroll', (event) => { this.onWindowScroll(event); });
            this.$html.on('nav:scrolling', (event) => { this.onNavScrolling(event); });
            this.$html.on('nav:static', (event) => { this.onNavStatic(event); });
        }
    }

    get $window() {
        return this.#$window;
    }

    get $html() {
        return this.#$html;
    }

    get $body() {
        return this.#$body;
    }

    get $header() {
        return this.#$header;
    }

    get $headerNav() {
        return this.#$headerNav;
    }

    get $alertBar() {
        return this.#$alertBar;
    }

    get $topBar() {
        return this.#$topBar;
    }

    get $bottomBar() {
        return this.#$bottomBar;
    }

    get $primaryNav() {
        return this.#$primaryNav;
    }

    get $primaryNavContainer() {
        return this.#$primaryNavContainer;
    }

    get $primaryNavDropdownMenus() {
        return this.#$primaryNavDropdownMenus;
    }

    get $primaryNavDropdownToggles() {
        return this.#$primaryNavDropdownToggles;
    }

    get $mobilePrimaryNavToggle() {
        return this.#$mobilePrimaryNavToggle;
    }

    get jumboMenu() {
        return this.#jumboMenu;
    }

    isScrolling() {
        return (this.$window.scrollTop() > this.$header.height() - this.$bottomBar.height() + this.headerBottomPadding) ? true : false;
    }

    closeDropdowns() {
        this.$body.trigger('click');
    }

    updateScroll() {
        if (this.isScrolling()) {
            if (!this.$header.hasClass('scrolling')) {
                this.$header.addClass('scrolling');
                this.$body.addClass('has-scrolling-nav');
                this.$html.trigger('nav:scrolling');
            }
        } else {
            if (this.$header.hasClass('scrolling')) {
                this.$header.removeClass('scrolling');
                this.$body.removeClass('has-scrolling-nav');
                this.$html.trigger('nav:static');
            }
        }
    }

    addHeaderPadding() {
        this.$header.css('padding-bottom', this.#$bottomBar.height());
        this.headerBottomPadding = this.#$bottomBar.height();
    }

    removeHeaderPadding() {
        this.$header.css('padding-bottom', '');
        this.headerBottomPadding = 0;
    }

    trigger(eventName, data) {
        return this.$header.trigger(eventName, data);
    }

    on (eventName, callback, data) {
        this.$header.on(eventName, callback, data);
    }

    onWindowScroll(event) {
        if (!(event.originalEvent instanceof Event)) {
			return null;
		}

        this.closeDropdowns();
        this.updateScroll();
    }

    onWindowResize(event) {
        if (!(event.originalEvent instanceof Event)) {
			return null;
		}

        if (this.$primaryNavContainer.hasClass('open')) {
            this.$primaryNavContainer.removeClass('open');
        }

        if (this.$body.hasClass('nav-open')) {
            this.$body.removeClass('nav-open');
        }

        this.closeDropdowns();

        if (this.isScrolling()) {
            this.addHeaderPadding();
        }
    }

    onNavScrolling(event) {
        if (!(event instanceof Object)) {
			return null;
		}

        this.addHeaderPadding();
    }

    onNavStatic(event) {
        if (!(event instanceof Object)) {
			return null;
		}

        this.removeHeaderPadding();
    }

    onMobilePrimaryNavToggleClick(event) {
        if (!(event.originalEvent instanceof Event)) {
			return null;
		}

        this.$primaryNavContainer.toggleClass('open');
        this.$body.toggleClass('nav-open');
    }
}